module.exports = __webpack_public_path__ + "static/img/5.6722850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/5.png
// module id = DGKk
// module chunks = 37